import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Power Meter Icon Style 01 - Network Check (Material Symbol)
 * Power meters are always "on" when online, use blue color
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:network_check
 */
export const Style01_NetworkCheck: React.FC<DeviceIconProps> = ({ 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = 'text-blue-500';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      network_check
    </span>
  );
};

export default Style01_NetworkCheck;
